module.exports=[
  {
    "Condition": "Above Benchmark",
    "ConditionHyphen": "Above Benchmark"
  },
  {
    "Condition": "At or Below Benchmark",
    "ConditionHyphen": "At or Below Benchmark"
  },
  {
    "Condition": "Above Criterion",
    "ConditionHyphen": "Above Criterion"
  },
  {
    "Condition": "At or Below Criterion",
    "ConditionHyphen": "At or Below Criterion"
  },
  {
    "Condition": "Detected",
    "ConditionHyphen": "Detected"
  },
  {
    "Condition": "Eutrophic",
    "ConditionHyphen": "Eutrophic"
  },
  {
    "Condition": "Fair",
    "ConditionHyphen": "Fair"
  },
  {
    "Condition": "Good",
    "ConditionHyphen": "Good"
  },
  {
    "Condition": "High",
    "ConditionHyphen": "High"
  },
  {
    "Condition": "Hypereutrophic",
    "ConditionHyphen": "Hyper-<br>eutrophic"
  },
  {
    "Condition": "Large",
    "ConditionHyphen": "Large"
  },
  {
    "Condition": "Low",
    "ConditionHyphen": "Low"
  },
  {
    "Condition": "Low Oxygen",
    "ConditionHyphen": "Low Oxygen"
  },
  {
    "Condition": "Medium",
    "ConditionHyphen": "Medium"
  },
  {
    "Condition": "Mesotrophic",
    "ConditionHyphen": "Meso-<br>trophic"
  },
  {
    "Condition": "Not Assessed",
    "ConditionHyphen": "Not Assessed"
  },
  {
    "Condition": "Not Detected",
    "ConditionHyphen": "Not Detected"
  },
  {
    "Condition": "Not Large",
    "ConditionHyphen": "Not Large"
  },
  {
    "Condition": "Oligotrophic",
    "ConditionHyphen": "Oligo-<br>trophic"
  },
  {
    "Condition": "Poor",
    "ConditionHyphen": "Poor"
  },
  {
    "Condition": "Satisfactory Oxygen",
    "ConditionHyphen": "Satisfactory Oxygen"
  },
  {
    "Condition": "Very Low Oxygen",
    "ConditionHyphen": "Very Low Oxygen"
  },
  {
    "Condition": "Very Poor",
    "ConditionHyphen": "Very Poor"
  },
  {
    "Condition": "Acidification",
    "ConditionHyphen": "Acidification"
  },
  {
    "Condition": "Atrazine Detection",
    "ConditionHyphen": "Atrazine Detection"
  },
  {
    "Condition": "Chlorophyll a",
    "ConditionHyphen": "Chlorophyll a"
  },
  {
    "Condition": "Oxygen (Dissolved)",
    "ConditionHyphen": "Oxygen (Dissolved)"
  },
  {
    "Condition": "Lake Drawdown Exposure",
    "ConditionHyphen": "Lake Drawdown Exposure"
  },
  {
    "Condition": "Shallow Water Habitat",
    "ConditionHyphen": "Shallow Water Habitat"
  },
  {
    "Condition": "Lake Habitat Complexity",
    "ConditionHyphen": "Lake Habitat Complexity"
  },
  {
    "Condition": "Microcystins Detection",
    "ConditionHyphen": "Microcystins Detection"
  },
  {
    "Condition": "Nitrogen (Total)",
    "ConditionHyphen": "Nitrogen (Total)"
  },
  {
    "Condition": "Phosphorus (Total)",
    "ConditionHyphen": "Phosphorus (Total)"
  },
  {
    "Condition": "Lakeshore Disturbance",
    "ConditionHyphen": "Lakeshore Disturbance"
  },
  {
    "Condition": "Riparian Vegetation Cover",
    "ConditionHyphen": "Riparian Vegetation Cover"
  }
]